// import React, { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import AdminAppBody from "../../../../components/admin/AdminAppBody";
// import PageHeading from "../../../../components/admin/common/PageHeading";
// import useApiCallHooks from "../../../../hooks/useApiCallHooks";
// import { toast } from "react-toastify";
// import { uiRoutes } from "../../../../routes/ui/uiRoutes";

// const EditBlog = () => {
//   const { id } = useParams(); // get :id from URL
//   const navigate = useNavigate();
//   const [formData, setFormData] = useState({
//     name: "",
//     image: null,
//     category: "",
//     created_by: "",
//     description: "",
//   });
//   const [imagePreview, setImagePreview] = useState(null);
//   const [response, loading, error, callAPI, statusCode] = useApiCallHooks();

//   // Fetch blog details
//   useEffect(() => {
//     callAPI("get", `admin/blogs/${id}`);
//   }, [id]);

//   // When blog data loads, set form fields
//   useEffect(() => {
//     if (response?.data && statusCode === 200) {
//       const blog = response.data;
//       setFormData({
//         name: blog.name || "",
//         category: blog.category || "",
//         created_by: blog.created_by || "",
//         description: blog.description || "",
//         image: null, // reset file input
//       });
//       setImagePreview(blog.image || null);
//     }
//   }, [response, statusCode]);

//   // Handle update
//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const submitData = new FormData();
//     Object.keys(formData).forEach((key) => {
//       if (formData[key] !== null) {
//         submitData.append(key, formData[key]);
//       }
//     });
//     callAPI("post", `admin/blogs/${id}?_method=PUT`, submitData); // Laravel style update
//   };

//   // After success
//   useEffect(() => {
//     if (statusCode === 202) {
//       toast.success("Blog updated successfully!");
//       setTimeout(() => {
//         navigate(uiRoutes.admin.blog.list);
//       }, 1000);
//     }
//   }, [response, statusCode, navigate]);

//   // Image preview
//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     setFormData({ ...formData, image: file });
//     if (file) {
//       const reader = new FileReader();
//       reader.onloadend = () => setImagePreview(reader.result);
//       reader.readAsDataURL(file);
//     }
//   };

//   return (
//     <AdminAppBody
//       loading={loading}
//       content={
//         <div className="container mt-5">
//           <PageHeading title="Edit Blog" subTitle="Update blog details" />
//           <div className="container card p-4 shadow-sm mt-3">
//             <form
//               onSubmit={handleSubmit}
//               className="row g-3"
//               encType="multipart/form-data"
//             >
//               <h6 className="">Edit Blog Form</h6>

//               {/* Name */}
//               <div className="col-md-4">
//                 <label className="form-label">Name</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   value={formData.name}
//                   onChange={(e) =>
//                     setFormData({ ...formData, name: e.target.value })
//                   }
//                 />
//                 <span className="val-message text-danger">
//                   {error?.message === "ValidationError" && error?.data?.name}
//                 </span>
//               </div>

//               {/* Category */}
//               <div className="col-md-4">
//                 <label className="form-label">Category</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   value={formData.category}
//                   onChange={(e) =>
//                     setFormData({ ...formData, category: e.target.value })
//                   }
//                 />
//                 <span className="val-message text-danger">
//                   {error?.message === "ValidationError" &&
//                     error?.data?.category}
//                 </span>
//               </div>

//               {/* Created By */}
//               <div className="col-md-4">
//                 <label className="form-label">Created By</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   value={formData.created_by}
//                   onChange={(e) =>
//                     setFormData({ ...formData, created_by: e.target.value })
//                   }
//                 />
//                 <span className="val-message text-danger">
//                   {error?.message === "ValidationError" &&
//                     error?.data?.created_by}
//                 </span>
//               </div>

//               {/* Image Upload */}
//               <div className="col-md-6">
//                 <label className="form-label">Image Upload</label>
//                 <input
//                   type="file"
//                   accept="image/*"
//                   className="form-control"
//                   onChange={handleImageChange}
//                 />
//                 {imagePreview && (
//                   <img
//                     src={imagePreview}
//                     alt="Preview"
//                     className="mt-2"
//                     style={{
//                       width: "100%",
//                       maxHeight: "200px",
//                       objectFit: "contain",
//                     }}
//                   />
//                 )}
//                 <span className="val-message text-danger">
//                   {error?.message === "ValidationError" && error?.data?.image}
//                 </span>
//               </div>

//               {/* Description */}
//               <div className="col-md-12">
//                 <label className="form-label">Description</label>
//                 <textarea
//                   className="form-control"
//                   rows="5"
//                   value={formData.description}
//                   onChange={(e) =>
//                     setFormData({ ...formData, description: e.target.value })
//                   }
//                 />
//                 <span className="val-message text-danger">
//                   {error?.message === "ValidationError" &&
//                     error?.data?.description}
//                 </span>
//               </div>

//               {/* Submit */}
//               <div className="col-4 mt-5 mb-5">
//                 <button type="submit" className="btn btn-primary w-100">
//                   Update Blog
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       }
//     />
//   );
// };

// export default EditBlog;
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import AdminAppBody from "../../../../components/admin/AdminAppBody";
import PageHeading from "../../../../components/admin/common/PageHeading";
import useApiCallHooks from "../../../../hooks/useApiCallHooks";
import { toast } from "react-toastify";
import { uiRoutes } from "../../../../routes/ui/uiRoutes";

// Draft.js imports
import { Editor } from "react-draft-wysiwyg";
import {
  EditorState,
  ContentState,
  convertToRaw,
} from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const EditBlog = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    image: null,
    category: "",
    created_by: "",
  });
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [imagePreview, setImagePreview] = useState(null);
  const [response, loading, error, callAPI, statusCode] = useApiCallHooks();

  // Fetch blog details
  useEffect(() => {
    callAPI("get", `admin/blogs/${id}`);
  }, [id]);

  // Populate fields when blog data loads
  useEffect(() => {
    if (response?.data && statusCode === 200) {
      const blog = response.data;

      setFormData({
        name: blog.name || "",
        category: blog.category || "",
        created_by: blog.created_by || "",
        image: null,
      });

      setImagePreview(blog.image || null);

      // Load description into Draft.js editor
      if (blog.description) {
        const contentBlock = htmlToDraft(blog.description);
        if (contentBlock) {
          const contentState = ContentState.createFromBlockArray(
            contentBlock.contentBlocks,
            contentBlock.entityMap
          );
          setEditorState(EditorState.createWithContent(contentState));
        }
      }
    }
  }, [response, statusCode]);

  // Handle update
  const handleSubmit = (e) => {
    e.preventDefault();

    const htmlDescription = draftToHtml(
      convertToRaw(editorState.getCurrentContent())
    );

    const submitData = new FormData();
    Object.keys(formData).forEach((key) => {
      if (formData[key] !== null) {
        submitData.append(key, formData[key]);
      }
    });
    submitData.append("description", htmlDescription);

    callAPI("post", `admin/blogs/${id}?_method=PUT`, submitData);
  };

  // Success redirect
  useEffect(() => {
    if (statusCode === 202) {
      toast.success("Blog updated successfully!");
      setTimeout(() => {
        navigate(uiRoutes.admin.blog.list);
      }, 1000);
    }
  }, [response, statusCode, navigate]);

  // Handle image preview
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setFormData({ ...formData, image: file });
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  return (
    <AdminAppBody
      loading={loading}
      content={
        <div className="container mt-5">
          <PageHeading title="Edit Blog" subTitle="Update blog details" />
          <div className="container card p-4 shadow-sm mt-3">
            <form
              onSubmit={handleSubmit}
              className="row g-3"
              encType="multipart/form-data"
            >
              <h6 className="">Edit Blog Form</h6>

              {/* Name */}
              <div className="col-md-4">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                />
              </div>

              {/* Category */}
              <div className="col-md-4">
                <label className="form-label">Category</label>
                <input
                  type="text"
                  className="form-control"
                  value={formData.category}
                  onChange={(e) =>
                    setFormData({ ...formData, category: e.target.value })
                  }
                />
              </div>

              {/* Created By */}
              <div className="col-md-4">
                <label className="form-label">Created By</label>
                <input
                  type="text"
                  className="form-control"
                  value={formData.created_by}
                  onChange={(e) =>
                    setFormData({ ...formData, created_by: e.target.value })
                  }
                />
              </div>

              {/* Image Upload */}
              <div className="col-md-6">
                <label className="form-label">Image Upload</label>
                <input
                  type="file"
                  accept="image/*"
                  className="form-control"
                  onChange={handleImageChange}
                />
                {imagePreview && (
                  <img
                    src={imagePreview}
                    alt="Preview"
                    className="mt-2"
                    style={{
                      width: "100%",
                      maxHeight: "200px",
                      objectFit: "contain",
                    }}
                  />
                )}
              </div>

              {/* Description (Draft.js editor) */}
              <div className="col-md-12">
                <label className="form-label">Description</label>
                <Editor
                  editorState={editorState}
                  onEditorStateChange={setEditorState}
                  wrapperClassName="demo-wrapper"
                  editorClassName="demo-editor form-control"
                  toolbarClassName="toolbar-class"
                  toolbar={{
                    options: [
                      "inline",
                      "blockType",
                      "list",
                      "link",
                      "image",
                      "history",
                    ],
                  }}
                  placeholder="Write your blog description..."
                />
              </div>

              {/* Submit */}
              <div className="col-4 mt-5 mb-5">
                <button type="submit" className="btn btn-primary w-100">
                  Update Blog
                </button>
              </div>
            </form>
          </div>
        </div>
      }
    />
  );
};

export default EditBlog;

